<div class="viewing-container" ngbDropdown>
  <span id="viewing-label" i18n>Viewing</span>
  <button
    id="row-dropdown-btn"
    class="no-style-button d-flex align-items-center gap-1"
    ngbDropdownToggle
    type="button"
    aria-haspopup="listbox"
    aria-controls="row-dropdown-menu"
    aria-labelledby="viewing-label row-dropdown-btn rows-label">
    <span>{{ top }}</span>
    <img class="chevron" src="assets/icons/dark/Chevron%20Down.svg" alt="" aria-hidden="true" height="16" width="16" />
  </button>
  <span id="rows-label" i18n>rows</span>

  <div
    ngbDropdownMenu
    id="row-dropdown-menu"
    class="dropdown-menu-custom"
    role="listbox"
    aria-labelledby="viewing-label">
    <button
      *ngFor="let option of options"
      ngbDropdownItem
      type="button"
      role="option"
      [class.selected]="top === option"
      [attr.aria-selected]="top === option"
      (click)="setSelection(option)">
      <img *ngIf="top === option" src="assets/icons/grey/Check.svg" alt="" aria-hidden="true" height="16" width="16" />

      <span>{{ option }}</span>
    </button>
  </div>
</div>
